import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Edge = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.349 13.684H8.874c0 .433.063.825.195 1.178a3.334 3.334 0 001.381 1.634c.309.196.646.359 1.005.484.356.13.729.226 1.107.288.821.13 1.658.123 2.477-.021a9.79 9.79 0 002.421-.783c.393-.18.79-.376 1.201-.594v3.805a13.453 13.453 0 01-2.711.978c-.457.112-.92.196-1.396.246-.486.054-.975.079-1.464.079a8.185 8.185 0 01-1.95-.232 7.679 7.679 0 01-1.762-.668 7.29 7.29 0 01-1.51-1.062 6.67 6.67 0 01-1.941-3.103 6.978 6.978 0 01-.267-1.953c0-.737.101-1.439.303-2.11a6.718 6.718 0 012.264-3.342 7.38 7.38 0 011.847-1.066 3.891 3.891 0 00-.869 1.329 5.682 5.682 0 00-.401 1.538h6.391c0-.646-.063-1.207-.196-1.689-.131-.484-.342-.885-.637-1.201A2.64 2.64 0 0013.23 6.7c-.462-.16-1.021-.241-1.675-.241-.771 0-1.543.111-2.314.344a9.804 9.804 0 00-2.2.955c-.695.412-1.335.897-1.919 1.452a9.167 9.167 0 00-1.474 1.819c.084-.742.247-1.474.485-2.18a9.304 9.304 0 01.912-1.938 8.622 8.622 0 011.303-1.609 7.735 7.735 0 011.655-1.235 8.45 8.45 0 011.955-.792 10.042 10.042 0 012.233-.254c.46 0 .917.041 1.375.124.457.084.903.196 1.339.342a8.012 8.012 0 012.315 1.239 7.95 7.95 0 011.711 1.833c.463.692.813 1.459 1.055 2.292s.365 1.701.365 2.602v2.23h-.002z",
    key: "k0"
  }));
});
Edge.displayName = 'Edge';
export var EdgeDimensions = {
  height: 24,
  width: 24
};